<template>
  <q-page padding>
    <div class="fixed-center text-center">
      <p>
        <img
          src="../assets/bolts.png"
          style="width:30vw;max-width:150px;"
        >
      </p>
      <p>Thanks so much for registering!</p>
      <p>We can't wait to show you what's inside. Why don't you grab a cuppa while we verify your details?</p>
      <p>We'll send you an email confirming your access shortly. Then you'll be able to log in with the email and password you provided and then watch the magic unfold!</p>
      <p>While you're waiting, <a href="https://climbicp.com.au">check out the rest of our website for the latest goss</a>.</p>
    </div>

  </q-page>
</template>

<script>
export default {
  name: 'PageThanksForRegistering'
}
</script>
